export const accessibilitySubNavToggle = {
  mounted() {
    const button = this.el;
    button.addEventListener('click', () => {
      button.parentElement.parentElement.classList.toggle('display-sub-nav');
      // Close any sibling sub menu that is open
      const accessibilityButtons = document.querySelectorAll(
        'button[data-accessibility="trigger"]'
      );
      accessibilityButtons.forEach((btn) => {
        const subNavIsOpen =
          btn?.parentElement?.parentElement?.classList.contains('display-sub-nav');
        const shouldBeClosed = btn.id !== button.id;
        if (subNavIsOpen && shouldBeClosed) {
          btn?.parentElement?.parentElement?.classList.remove('display-sub-nav');
        }
      });
    });
  }
};
